import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeFactSkeleton } from './TypeFact';

export interface TypeBlockNumberedBlocksFields {
    internalTitle?: EntryFieldTypes.Symbol;
    facts?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeFactSkeleton>>;
}

export type TypeBlockNumberedBlocksSkeleton = EntrySkeletonType<TypeBlockNumberedBlocksFields, 'blockNumberedBlocks'>;
export type TypeBlockNumberedBlocks<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockNumberedBlocksSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockNumberedBlocks<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockNumberedBlocks<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockNumberedBlocks';
}
